import React, { useContext } from 'react'
import { Container, Typography, createMuiTheme, Grid, ThemeProvider, makeStyles } from '@material-ui/core'
import MaterialTextField from '@material-ui/core/TextField'
import { useTheme } from '@material-ui/core/styles'
import { containerStyle, profileStyle } from '../styles/styles'
import {
  AMNTextField,
  AMNPhoneNumber,
  AMNDropDown,
  AMNEmail
} from '@amn/shared'
import { mainTheme, textFieldTheme } from '../App'

const useCustomStyles = makeStyles(() => ({
  fullWidthDropdown: {
    '& .MuiFormControl-root': {
      width: '100% !important'
    },
    '& .MuiTextField-root': {
      width: '100% !important'
    },
    '& > div': {
      width: '100% !important'
    },
    width: '100% !important'
  }
}))

const EvaluatorContainer = (props) => {
  const classes = containerStyle()
  const profileClasses = profileStyle()
  const customClasses = useCustomStyles()
  const theme = useTheme()

  const [disable, setDisable] = React.useState(true)

  const handleChange = (event, type) => {
    if (type === 'phone') {
      props.updateReference(props.index, {
        [event.target.id]:
          event.target.value !== '' && event.target.value !== '('
            ? event.target.value
            : null
      })
    } else {
      props.updateReference(props.index, {
        [event.target.id]: event.target.value
      })
    }
  }

  const dropDownChange = (event, type) => {
    if (type === 'title') {
      if (event.target.value === 'Other') setDisable(false)
      else setDisable(true)

      props.updateReference(props.index, {
        title: event.target.value,
        amhTitle: event.target.value,
        amhTitleId: parseInt(
          props.jobTitles.filter(
            (jobTitle) => jobTitle.label === event.target.value
          )[0].value
        )
      })
    } else if (type === 'supervisorPhoneType') {
      props.updateReference(props.index, {
        supervisorPhoneType: props.phoneTypes.filter(
          (item) => item.label === event.target.value
        )[0].value,
        supervisorPhoneName: props.phoneTypes.filter(
          (item) => item.label === event.target.value
        )[0].label
      })
    } else {
      props.updateReference(props.index, {
        [type]: event.target.value
      })
    }
  }

  return (
    <div>
      <ThemeProvider theme={textFieldTheme}>
        <form className={classes.root} noValidate autoComplete='off'>
          <ThemeProvider theme={mainTheme}>
            {props.isEvaluator ? (
              <Typography variant='h6'>Your Profile</Typography>
            ) : props.index === 0 ? (
              <Typography variant='h6'>Reference</Typography>
            ) : null}
          </ThemeProvider>
          {props.isEvaluator ? (
            <div className={classes.inputField}>
              <div className={classes.evaluatorName}>
                <Typography variant='h5'>
                  {props.reference.supervisorName ?? ''}
                </Typography>
              </div>
              <div className={classes.evaluatorEmail}>
                <Typography variant='subtitle1'>
                  {props.reference.email ?? ''}
                </Typography>
              </div>
              <div className={classes.evaluatorEmail}>
                <Typography variant='subtitle1'>
                  {
                    (props.reference.evaluatorPhones &&
                      props.reference.evaluatorPhones.length > 0 &&
                      props.reference.evaluatorPhones[0].phoneNumber !== ' ')
                      ? (
                        <div>
                          {props.reference.evaluatorPhones[0].type ?? ''} -{' '}
                          {props.reference.evaluatorPhones[0].phoneNumber ?? ''}
                        </div>
                      )
                      : null
                  }
                </Typography>
              </div>
            </div>
          ) : (
            <div>
              <div className={classes.inputField}>
                <AMNTextField
                  id='supervisorFirstName'
                  label='Evaluator First Name'
                  variant='filled'
                  error={props.error && !props.reference.supervisorFirstName}
                  required
                  errorText='Required'
                  className={classes.unitDescription}
                  value={props.reference.supervisorFirstName}
                  onChange={(e) => handleChange(e)}
                  theme={textFieldTheme}
                />
              </div>
              <div className={classes.inputField}>
                <AMNTextField
                  id='supervisorLastName'
                  required
                  error={props.error && !props.reference.supervisorLastName}
                  errorText='Required'
                  label='Evaluator Last Name'
                  variant='filled'
                  className={classes.unitDescription}
                  value={props.reference.supervisorLastName}
                  onChange={(e) => handleChange(e)}
                  theme={textFieldTheme}
                />
              </div>
              <div style={{ height: '1px', backgroundColor: '#CCCCCC', margin: '5px 0px' }} />
              <div style={{ marginBottom: '21px' }}>
                <Typography variant='body2' style={{ color: '#000000', fontWeight: 'normal', fontSize: '12px' }}>
                  Evaluator's Contact Information (at-least one is required)
                </Typography>
              </div>

              <div className={classes.inputField}>
                <AMNEmail
                  id='email'
                  label='Evaluator Email'
                  variant='filled'
                  errorText={
                    !props.reference.email ? 'Required' : 'Invalid Email'
                  }
                  error={props.error && !props.reference.email && !props.reference.supervisorPhoneNumber}
                  className={classes.unitDescription}
                  value={props.reference.email ?? ''}
                  onChange={(e) => handleChange(e)}
                  theme={textFieldTheme}
                />
              </div>
              <div className={classes.inputField}>
                <div className={classes.evaluator}>
                  <div className={classes.inputFieldNameDropDownSmall}>
                    <AMNDropDown
                      id='supervisorPhoneType'
                      header='Phone Type'
                      variant='filled'
                      value={props.reference.supervisorPhoneName}
                      options={props.phoneTypes}
                      className={classes.Name}
                      onChange={(event) => {
                        dropDownChange(event, 'supervisorPhoneType')
                      }}
                      theme={textFieldTheme}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <AMNPhoneNumber
                      id='supervisorPhoneNumber'
                      label='Evaluator Phone Number'
                      errorText={
                        !props.reference.supervisorPhoneNumber
                          ? 'Required'
                          : 'Invalid Phone Number'
                      }
                      error={props.error && !props.reference.supervisorPhoneNumber && !props.reference.email}
                      variant='filled'
                      className={classes.NameSecond}
                      value={props.reference.supervisorPhoneNumber ?? ''}
                      onChange={(e) => handleChange(e, 'phone')}
                      theme={textFieldTheme}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div style={{ height: '1px', backgroundColor: '#CCCCCC', margin: '5px 0px' }} />

          <div className={classes.inputField}>
            <div className={classes.evaluator}>
              <div className={classes.inputFieldNameDropDown} style={{ flex: 1 }}>
                <AMNDropDown
                  header='Evaluator Title'
                  variant='filled'
                  id='Title'
                  value={props.reference.amhTitle ?? ''}
                  error={props.error && !props.reference.amhTitle}
                  errorText='Required'
                  options={[...props.jobTitles]}
                  className={customClasses.fullWidthDropdown}
                  onChange={(e) => dropDownChange(e, 'title')}
                  theme={textFieldTheme}
                />
              </div>

              {props.reference.amhTitleId === 30 ? (
                <div className={classes.inputFieldNameDropDown}>
                  <AMNTextField
                    id='otherSupervisorTitle'
                    label='Other Evaluator Title'
                    variant='filled'
                    errorText='Required'
                    error={
                      props.error &&
                      props.reference.amhTitleId === 30 &&
                      !props.reference.otherSupervisorTitle
                    }
                    required
                    className={classes.NameSecond}
                    value={
                      props.reference.amhTitleId === 30 && props.isEvaluator
                        ? props.reference.title
                        : props.reference.otherSupervisorTitle
                    }
                    onChange={(e) => handleChange(e)}
                    theme={textFieldTheme}
                  />
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </form>
      </ThemeProvider>
    </div>
  )
}

export default EvaluatorContainer
